var audio_rtlignore_default = {
  "fontElementMap": "eNq7K",
  "container": "IcgsD",
  "customPlayer": "ACpFH",
  "slim": "_43q5Z",
  "playPauseButton": "qyNO8",
  "coverImage": "_0oO05",
  "trackDetailsContainer": "EwcFQ",
  "controlsContainer": "H9jBv",
  "controlsGroup": "PDpGq",
  "sliderContainer": "_6mlVJ",
  "audioDuration": "_7mDef",
  "isLoading": "qImzn",
  "audioDetails": "_1Zf0Q",
  "authorName": "o0aLm",
  "title": "-Hmk9",
  "dropdownMenuWrapper": "_5jy-j",
  "dropdownSelectedButton": "xa4TJ",
  "dropdownContent": "guZva",
  "dropdownContentWithIcon": "_8lThG",
  "audioLoader": "_3ycTn"
};
export {
  audio_rtlignore_default as default
};
//# sourceMappingURL=audio.rtlignore-scss.js.map
